
import { getGradientFromPaletteColor } from "../palettes/colorPalette";

export function generatePaletteGLSLMapping(colorPalette: any) {
 return `
        
        if(key ==  16) {
            ${getGradientFromPaletteColor("BloodA")}
            match = true;
        }
        
        if(key ==  32) {
            ${getGradientFromPaletteColor("VirusA")}
            match = true;
        }
        
        if(key ==  48) {
            ${getGradientFromPaletteColor("VirusB")}
            match = true;
        }
        
        if(key ==  64) {
            ${getGradientFromPaletteColor("ImmuneCellA")}
            match = true;
        }
        
        if(key ==  80) {
            ${getGradientFromPaletteColor("ImmuneCellB")}
            match = true;
        }
        
        if(key ==  96) {
            ${getGradientFromPaletteColor("ImmuneCellC")}
            match = true;
        }
        
        if(key ==  112) {
            ${getGradientFromPaletteColor("VirusTint")}
            match = true;
        }
        
        if(key ==  128) {
            ${getGradientFromPaletteColor("VirusDarker")}
            match = true;
        }
        
        if(key ==  144) {
            ${getGradientFromPaletteColor("VirusLighter")}
            match = true;
        }
        
        if(key ==  160) {
            ${getGradientFromPaletteColor("Tag")}
            match = true;
        }
        
        if(key ==  176) {
            ${getGradientFromPaletteColor("Bullet")}
            match = true;
        }
        `
}
export const paletteSheetVCuttoff = 1;
